import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-lg text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]",
  {
    variants: {
      variant: {
        default:     "bg-brand-gradient text-white shadow-sm hover:shadow-md hover:opacity-90",
        outline:     "border border-brand-300 bg-white text-brand-700 hover:bg-brand-50 hover:border-brand-400",
        ghost:       "text-brand-600 hover:bg-brand-100 hover:text-brand-700",
        destructive: "bg-red-500 hover:bg-red-600 text-white shadow-sm",
        warning:     "bg-amber-500 hover:bg-amber-600 text-white shadow-sm",
        success:     "bg-emerald-500 hover:bg-emerald-600 text-white shadow-sm",
        secondary:   "bg-brand-100 text-brand-700 hover:bg-brand-200",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm:      "h-8 px-3 text-xs",
        lg:      "h-12 px-8 text-base",
        icon:    "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export function Button({ className, variant, size, ...props }) {
  return (
    <button
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}
